import React, { PureComponent } from "react";
import { Modal, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toast } from "react-toastify";
import { ConfirmationComponent } from "../../ConfirmationComponent";
import { withRouter } from "react-router-dom";
import EditAgendaForm from "./editAgenda";
import { loadPageInfo, updateMom } from "../../../actions/mom.action";
import { get } from "lodash";
import { ERROR_MSG } from "../../../constant";
import moment from "moment";
import { dateFormatWithTime } from "../../../helper";
import { successToastStyle, errorToastStyle } from "../../../customToast";
import htmlToFormattedText from "html-to-formatted-text";
import { LoaderPage } from "../../../component/Loader";

export class EditAgenda extends PureComponent {
  state = {
    error: {
      agendaName: {
        error: false,
        message: ""
      },
      venue: {
        error: false,
        message: ""
      },
      meetingMode: {
        error: false,
        message: ""
      },
      meetingChairedBy: {
        error: false,
        message: ""
      }
    },
    formData: this.props.formData
  };
  isApiLoaded = false;

  async componentDidMount() {
    const { loadPageInfo } = this.props;
    loadPageInfo();
  }

  onChange = (key, value) => {
    const { formData } = this.state;
    this.setState({
      formData: {
        ...formData,
        [key]: value
      },
      dataUnsaved: true
    });
  };

  changeFromDateTime = (meetingDate, meetingFromTime) => {
    let month = meetingDate.getMonth() + 1;
    let day = meetingDate.getDate();
    let year = meetingDate.getFullYear();
    let dateTimeString =
      year + "-" + month + "-" + day + " " + meetingFromTime + ":00";
    let dateTimeFrom = new Date(dateTimeString.replace(/-/g, "/"));
    return Date.parse(moment(dateTimeFrom).toISOString());
  };

  changeToDateTime = (meetingDate, meetingTimeTo) => {
    let month = meetingDate.getMonth() + 1;
    let day = meetingDate.getDate();
    let year = meetingDate.getFullYear();
    let dateTimeString =
      year + "-" + month + "-" + day + " " + meetingTimeTo + ":00";
    let dateTimeTo = new Date(dateTimeString.replace(/-/g, "/"));
    return Date.parse(moment(dateTimeTo).toISOString());
  };
  updateAgenda = async () => {
    this.setState({ showLoader: true });
    const { updateMom, location, onClose, getInitialCalls } = this.props;
    const { formData } = this.state;
    //console.log(formData , this.props.formData);

    formData.meetingTimeFrom = this.changeFromDateTime(
      new Date(formData.meetingDate) || formData.meetingDate,
      moment.utc(dateFormatWithTime(formData.meetingTimeFrom)).format("HH:mm")
    );

    formData.meetingTimeTo = this.changeToDateTime(
      new Date(formData.meetingDate) || formData.meetingDate,
      moment.utc(dateFormatWithTime(formData.meetingTimeTo)).format("HH:mm")
    );

    this.openConfirmationAlert();
    const formDataAgendaName = htmlToFormattedText(formData.agendaName);
    const formDataMeetingChairedBy = htmlToFormattedText(
      formData.meetingChairedBy
    );
    formData.agendaName = formDataAgendaName;
    formData.meetingChairedBy = formDataMeetingChairedBy;

    //fileAttachment start
    if (formData && formData.fileDTOList && formData.fileDTOList.length) {
      const files = formData.fileDTOList.map(value => value.id);
      formData.fileAttachment = files && files[0];
    }
    //fileAttachment stop
    //console.log("check here...", formData);
    //need to remove in pragati phase-2 start
    const newFormData = {
      ...formData,
      users: formData.users.map(user => {
        if (user.guestCategory === "NA") {
          return { ...user, guestCategory: null };
        }
        return user;
      })
    };
    //console.log("again check here...", newFormData);
    //need to remove in pragati phase-2 end

    let response = await updateMom(undefined, newFormData);
    if (response.status) {
      this.setState({ showLoader: false });
      const { data } = response;
      toast.success(
        <p className="toast-text-alignment">Agenda updated successfully</p>,
        successToastStyle
      );
      let _id =
        location && location.state && location.state.agendaId
          ? get(location, "state.agendaId")
          : data;
      onClose();
      getInitialCalls(_id);
    } else {
      toast.error(
        <p className="toast-text-alignment">{response.message}</p>,
        errorToastStyle
      );
    }
  };

  openConfirmationAlert = () => {
    this.setState(prevState => ({
      showAlert: !prevState.showAlert
    }));
  };

  validateError = callback => {
    const {
      error,
      formData: {
        agendaName,
        venue,
        meetingChairedBy,
        meetingMode,
        meetingType
      }
    } = this.state;
    if (
      !error.agendaName ||
      get(error, "agendaName.error") ||
      (!error.venue || get(error, "venue.error")) ||
      (!error.meetingChairedBy || get(error, "meetingChairedBy.error")) ||
      !meetingType
    ) {
      this.setState({
        error: {
          agendaName: {
            error: !agendaName,
            message: !agendaName && ERROR_MSG.DEFAULT_MSG
          },
          venue: {
            error: !venue,
            message: !venue && ERROR_MSG.DEFAULT_MSG
          },
          meetingMode: {
            error: !meetingMode,
            message: !meetingMode && ERROR_MSG.DEFAULT_MSG
          },
          meetingChairedBy: {
            error: !meetingChairedBy,
            message: !meetingChairedBy && ERROR_MSG.DEFAULT_MSG
          },
          meetingType: {
            error: !meetingType,
            message: !meetingType && ERROR_MSG.DEFAULT_MSG
          }
        }
      });
      toast.error(
        <p className="toast-text-alignment">{ERROR_MSG.INVALID_FORM}</p>,
        errorToastStyle
      );
    } else {
      this.openConfirmationAlert();
    }
  };

  onError = (key, value) => {
    this.setState(prevState => ({
      error: {
        ...prevState.error,
        [key]: value
      }
    }));
  };

  render() {
    const { onClose, pageInfo, agendaMeetingTypeDetails } = this.props;
    const { showAlert, isApiLoading, error, formData, showLoader } = this.state;

    return (
      <React.Fragment>
        <Modal
          size="lg"
          show={true}
          onHide={onClose}
          className="edit-issue edit-agenda"
        >
          <ConfirmationComponent
            show={showAlert}
            isLoading={isApiLoading}
            modalClass={"confirmation-modal"}
            saveHandler={this.updateAgenda}
            closeHandler={this.openConfirmationAlert}
            content={"Are you sure you want to do this?"}
          />
          <Modal.Header closeButton />
          <LoaderPage loading={showLoader} />
          <Modal.Body className="edit-agenda-modal">
            <EditAgendaForm
              formData={formData}
              venues={pageInfo && pageInfo.venueList}
              meetingModesOptions={pageInfo && pageInfo.meetingModes}
              agendaSenders={pageInfo && pageInfo.agentSentFromList}
              onChange={this.onChange}
              validateField={this.validateField}
              onError={this.onError}
              error={error}
              agendaMeetingTypeDetails={agendaMeetingTypeDetails}
            />
          </Modal.Body>
          <Button
            onClick={this.validateError}
            className="btn-orange edit-submit-button "
          >
            {" "}
            Update{" "}
          </Button>
        </Modal>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    pageInfo: state.createAgendaReducer.pageInfo
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      loadPageInfo,
      updateMom
    },
    dispatch
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(EditAgenda)
);
